import { render, staticRenderFns } from "./orderProductPromotionDetail.vue?vue&type=template&id=40a7d35e&scoped=true"
import script from "./orderProductPromotionDetail.vue?vue&type=script&lang=js"
export * from "./orderProductPromotionDetail.vue?vue&type=script&lang=js"
import style0 from "./orderProductPromotionDetail.vue?vue&type=style&index=0&id=40a7d35e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7d35e",
  null
  
)

export default component.exports